import { List, NotificationBanner } from '@velocity/ui'

import { useContent } from '@ngb-frontend/shared/context'
import { PhoneButton } from '@ngb-frontend/shared/ui'

const prefix = 'steps.malfunction.notification'

interface ContactDirectlyBannerProps {
  callLabel?: boolean
  onClose?: () => void
  margin?: React.ComponentProps<typeof NotificationBanner>['margin']
}

export const ContactDirectlyBanner: React.FC<ContactDirectlyBannerProps> = ({
  callLabel,
  onClose,
  margin,
}) => {
  const c = useContent()

  return (
    <NotificationBanner
      kind="warning"
      title={c(`${prefix}.title`)}
      data-e2e-component="contact-directly-banner"
      margin={margin}
      onClose={onClose}
    >
      <List margin={{ bottom: '04' }}>
        <List.Item>{c(`${prefix}.options.unsafe`)}</List.Item>
        <List.Item>{c(`${prefix}.options.warningLights`)}</List.Item>
      </List>
      <PhoneButton withCallLabel={callLabel} />
    </NotificationBanner>
  )
}
